import React,{ useEffect, useState } from 'react'
import RTable from 'react-table'
import { connect } from 'react-redux'
import { Button } from 'semantic-ui-react'
import { getFormValues, FieldArray, Field } from 'redux-form'
import { Card, CardContent, Collapse, CardHeader, CircularProgress, Fade } from '@material-ui/core'
import ItemModal from './AddItemModal' 

import { SelectItemsContainer, BudgetContainer } from './styled'
import { ProcurementBody } from 'routes/ProcurementSystem/styled'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import { costCenterColumn, wbsColumn, internalOrderColumn, itemColumns } from '../../Create/data'
import { showPrItemModal, validateBudget, selectSubCategory } from 'ducks/purchaseRequisition'
import { getOptionTitle, numberFormat, calculateTotalAmount, calculateVat, calculateTotalIncludeVat } from '../../helper'
import { getWbsElements, getMaterials } from 'ducks/options'
import { showModal as showModalAlert } from 'ducks/app'

const itemFormToBudgetFormat = (item) => {
  return ({
    accountAssignmentCategoryCode: item.accountAssignment,
    glAccountCode: item.glAccountCode ? item.glAccountCode.padStart(10, '0') : '',
    wbsElementCode: item.wbsElement||'',
    orderTypeCode: item.orderType||'',
    orderCode: item.orderNo||'',
    costCenterCode: item.costCenter ? item.costCenter.padStart(10, '0') : '',
    coAreaCode: item.controllingArea||'',
    salesOrder: item.sellOrder||'',
    totalAmountEstimated: Number(item.totalAmount),
  })
}

const summaryDataForCheckBudget = (valueForm) => {
  const { companyCode, items } = valueForm
  let result = {
    year: valueForm.documentDate.getFullYear(),
    companyCode: companyCode,
    lines: [],
  }

  items.forEach(item => {
    let aa = item.accountAssignment
    if(!item.deleted){
      if (result.lines.length === 0) {
        let newItem = itemFormToBudgetFormat(item)
  
        if (aa === 'A' || aa === 'P' || aa === 'R' || aa === 'W') { // work around for ignore service bug
          newItem.coAreaCode = ''
        }
  
        result.lines.push(newItem)
      } else {
        
        var itemLine = undefined
        if (aa === 'K' || aa === 'Z') {
          itemLine = result.lines.find(i => i.glAccountCode === item.glAccountCode.padStart(10, '0') && 
                                            i.costCenterCode === item.costCenter.padStart(10, '0'))
          if (itemLine) {
            itemLine.totalAmountEstimated = Number(itemLine.totalAmountEstimated) + Number(item.totalAmount)
          } else {
            result.lines.push(itemFormToBudgetFormat(item))
          }
        } else if (aa === 'F') {
          itemLine = result.lines.find(i => i.glAccountCode === item.glAccountCode.padStart(10, '0') && 
                                            i.orderCode === item.orderNo && 
                                            i.orderTypeCode === item.orderType)
          if (itemLine) {
            itemLine.totalAmountEstimated = Number(itemLine.totalAmountEstimated) + Number(item.totalAmount)
          } else {
            result.lines.push(itemFormToBudgetFormat(item))
          }
        } else if (aa === 'A' || aa === 'P' || aa === 'R' || aa === 'W') {
          itemLine = result.lines.find(i => i.wbsElementCode === item.wbsElement)
          if (itemLine) {
            itemLine.totalAmountEstimated = Number(itemLine.totalAmountEstimated) + Number(item.totalAmount)
          } else {
            var wbsItem = itemFormToBudgetFormat(item)
            wbsItem.coAreaCode = '' // work around for ignore service bug
            result.lines.push(wbsItem)
          }
        }
      }
    }
  })

  return result
}

const onValidateBudgetSuccess = (props) => (budgetData) => {
  const { newRawData, change, costCenterOptions, glAccountOptions, wbsOptions, orderOptions } = props
  let result = {
    costCenter: [],
    wbs: [],
    internalOrder: [],
  }
  
  // Cost Center
  let listCostCenter = newRawData.lines.filter(b => b.accountAssignmentCategoryCode === 'K' || b.accountAssignmentCategoryCode === 'Z') || undefined
  if (listCostCenter) {
    listCostCenter.forEach(c => {
      const costCenter = c.costCenterCode.removeLeadingZero()
      const glAccount = c.glAccountCode.removeLeadingZero()
      let budgets = budgetData.find(
        b => b.code.removeLeadingZero() === costCenter.removeLeadingZero() && 
        b.code2.removeLeadingZero() === glAccount.removeLeadingZero())
      if (budgets) {
        result.costCenter.push(budgets)
      } else {
        
        result.costCenter.push({
          code: costCenter, 
          description: getOptionTitle(costCenterOptions, costCenter, false),
          code2: glAccount, 
          description2: getOptionTitle(glAccountOptions, glAccount, false),
          plan: null, assigned: 0, available: 0, currencyCode: 'THB',
        })
      }
    })
  }

  //Internal Order
  let listOrder = newRawData.lines.filter(b => b.accountAssignmentCategoryCode === 'F') || undefined
  if (listOrder) {
    listOrder.forEach(o => {
      let budgets = budgetData.find(
        b => b.code.removeLeadingZero() === o.orderCode.removeLeadingZero() && 
             b.code2.removeLeadingZero() === o.glAccountCode.removeLeadingZero())
      if (budgets) {
        budgets.code = budgets.code.removeLeadingZero()
        result.internalOrder.push(budgets)
      } else {
        const glAccount = o.glAccountCode.removeLeadingZero()
        const orderCode = o.orderCode.removeLeadingZero()
        result.internalOrder.push({
          code: orderCode, 
          description: getOptionTitle(orderOptions, o.orderCode, false).replace(`${o.orderCode} : `, ''),
          code2: glAccount, 
          description2: getOptionTitle(glAccountOptions, glAccount, false).replace(`${glAccount} : `, ''),
          plan: null, assigned: 0, available: 0, currencyCode: 'THB',
        })
      }
    })
  }
  
  // WBS
  let listWbs = newRawData.lines.filter(b => b.accountAssignmentCategoryCode === 'A' ||
                                                b.accountAssignmentCategoryCode === 'P' ||
                                                b.accountAssignmentCategoryCode === 'R' ||
                                                b.accountAssignmentCategoryCode === 'W') || undefined
  if (listWbs) {
    listWbs.forEach(w => {
      let budgets = budgetData.find(b => b.wbsElementNo === w.wbsElementCode)
      if (budgets) {
        let wbsResult = checkLevelBudget(budgets, budgetData).reverse()
        wbsResult.forEach(wr => {
          if (!result.wbs.find(i => i.wbsElementNo === wr.wbsElementNo)) {
            result.wbs.push(wr)
          }
        })
        result.wbs.sort(function(a, b) {
          if(a.code < b.code) { return -1 }
          if(a.code > b.code) { return 1 }
          return 0
        })
      } else {
        result.wbs.push({
          code: w.wbsElementCode, 
          description: getOptionTitle(wbsOptions, w.wbsElementCode, false),
          code2: '', description2: '',
          plan: null, assigned: 0, available: 0, currencyCode: 'THB',
        })
      }
    })
  }

  change('budgetData', result)
}

const checkLevelBudget = (current, list, result = []) => {
  if (!current) {
    return result
  }

  var next = {}
  if (result.length === 0) {
    result.push(current)
    next = list.find(b => b.wbsElementNo === current.wbsControlBudget)
    return checkLevelBudget(next, list, result)
  } else if (result.length === 1) {
    if (current.wbsControlBudget === '') { //End of line
      result.push(current)
      return result
    }

    if (current.plan !== 0) {
      result.push(current)
      next = list.find(b => b.wbsElementNo === current.wbsControlBudget)
      return checkLevelBudget(next, list, result)
    } else {
      next = list.find(b => b.wbsElementNo === current.wbsControlBudget)
      return checkLevelBudget(next, list, result)
    }
  } else if (result.length === 2) {
    if (current.wbsControlBudget === '') { //End of line
      result.push(current)
      return result
    } else {
      next = list.find(b => b.wbsElementNo === current.wbsControlBudget)
      return checkLevelBudget(next, list, result)
    }
  } else {
    return result
  }
}

const onSubmitItem = (fields,change) => (data) => {
  fields.push(data)
  fields.map((field, index) => change(`${field}.lineNo`, index + 1))
  change('vatRate', data.currency === 'THB' ? 7 : 0)
}

const onDeletePRItem = (fields,change,index) => {
  const x = fields.getAll()
  var clone = JSON.parse(JSON.stringify(fields.getAll()));
  const result = []
  clone.forEach((v,i)=>{
    if(i!==index)
    result.push({
      ...v,
      lineNo:i>index?i:i+1,
      startDate:x[i].startDate,
      deliveryDate:x[i].deliveryDate,
      createdDate:x[i].createdDate,
      modifiedDate:x[i].modifiedDate,
    })
  })   
  change('items', result)
}

const editPrItem = (index, change) => (data) => {
  change(`items[${index}]`, data)
  change('vatRate', data.currency === 'THB' ? 7 : 0)
}

const renderTableItems = (props) => {
  const { fields, recommendItems, change, items, showPrItemModal, assetOptions,
    budgetTypeOptions, unitOptions, currencyOptions, accountAssignmentOptions, 
    materialGroupOptions, plantOptions, storageLocationOptions, glAccountOptions,
    costCenterByRequester, menuSubCategory,  purchasingGroupOptions, costCenterOptions,
    orderOptions, purchasingOrgOptions, wbsOptions,profitCenterOptions, vatRate, valueForm,
    defaultCurrency, showModalAlert, subCategory } = props
    
    const onDeletePRItemById = () => {
      const oldItems = items.filter(i => i.id !== 0);
      const newItems = items.filter(i => i.id === 0);
      const OldItemsNewPlant = oldItems.find(item => oldItems.some(o => o.deleted && o.plant !== item.plant))?.plant; 
      const OldItemsNewPurchasingGroup = oldItems.find(item => oldItems.some(o => o.deleted && o.plant !== item.plant))?.purchasingGroup
      let newPurchasingOrg = oldItems.find(item => oldItems.some(o => o.deleted && o.plant !== item.plant))?.purchasingOrg 
      
      if (newItems.length) {
        const newPlant = newItems.find(item => oldItems.some(o => o.plant !== item.plant))?.plant;
        const newPurchasingGroup = newItems.find(item => oldItems.some(o => o.plant !== item.plant))?.purchasingGroup;
        
        if (newPlant) {
          newPurchasingOrg = newItems.find(item => oldItems.some(o => o.plant !== item.plant))?.purchasingOrg
          showModalAlert(true, '', `This item has been changed plant to ${newPlant}.`);
          items.forEach((_, index) => {
            change(`items[${index}].plant`, newPlant);
            change(`items[${index}].purchasingGroup`, newPurchasingGroup);
            change(`items[${index}].purchasingOrg`, newPurchasingOrg)
          });
        }
      } else if (OldItemsNewPlant) {
        showModalAlert(true, '', `This item has been changed plant to ${OldItemsNewPlant}.`);
        items.forEach((_, index) => {
          change(`items[${index}].plant`, OldItemsNewPlant);
          change(`items[${index}].purchasingGroup`, OldItemsNewPurchasingGroup);
          change(`items[${index}].purchasingOrg`, newPurchasingOrg)
        });
      }

    };

  // fields.map((field, index) => change(`${field}.lineNo`, index + 1))
  return (
    <SelectItemsContainer>
      <Card>
        <CardHeader 
          title='Items'
          action={
            <div className='cardHeaderActions'>
              <Button type='button' className='hiddenButton' circular icon='chevron up' />
            </div>
          }
        />
        <CardContent>
          <div className={`tableContainer ${recommendItems&&recommendItems.length?'':'tableNoRec'}`}>
            <RTable
              className='prItem'
              minRows={items.length > 10 ? 10 : items.length||5}
              showPagination={items.length > 10}
              defaultPageSize={10}
              sortable={false}
              columns={
                itemColumns({ 
                  withActions: true, fields, items, change, showPrItemModal, 
                  budgetTypeOptions, assetOptions, unitOptions, currencyOptions, 
                  accountAssignmentOptions, materialGroupOptions, profitCenterOptions,
                  plantOptions, storageLocationOptions, costCenterByRequester, 
                  menuSubCategory, purchasingGroupOptions, glAccountOptions, costCenterOptions, 
                  editPrItem, onSubmitItem, onDeletePRItem, orderOptions, purchasingOrgOptions, isEditPR:true, wbsOptions,
                  defaultCurrency, onDeletePRItemById
                })}
              data={items}
              getTrProps={(state, rowInfo, instance) => {
                if (rowInfo) {
                  if(rowInfo.original.deleted){
                    return {
                      style: {
                        borderRadius: '0.25rem',
                        alignItems: 'center',
                        background: 'red',
                        opacity: '0.5',
                        color: '#fff',
                        textDecoration: 'line-through',
                      }
                    }
                  }
                  return {
                    style: {
                      background: 'none',
                      alignItems: 'center'
                    }
                  }
                }
                return {};
              }}
            />
            <div className='totalContent'>
              <span className='labelText'>Total Amount </span>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                {numberFormat(valueForm.totalAmount)}
                <span style={{ marginLeft: '5px', fontWeight: 'bold' }}>{` ${defaultCurrency}`}</span>
              </div>
            </div>
            <div className='totalContent'>
              <div style={{ width: 'auto', display: 'flex', flexDirection: 'row' }}>
                <span className='labelText'>VAT</span>
                <Field 
                  name='vatRate' 
                  containerStyle={{ marginRight: '0px' }} 
                  suffix='%' 
                  marginLess
                  type={type.number} 
                  allowNegative={false} 
                  onChange={(v=>{
                    calculateTotalAmount(items,change,true)
                    calculateVat(items,v,change,true)
                    calculateTotalIncludeVat(items,v,change,true)
                  })}
                  component={FieldInput} />
                <span style={{ display: 'flex', alignItems: 'center', marginRight: '0px', marginLeft: '15px' }}>
                  {numberFormat(valueForm.vatAmount)}
                  <span style={{ marginLeft: '5px', fontWeight: 'bold' }}>{` ${defaultCurrency}`}</span>
                </span>
              </div>
            </div>
            <div className='totalContent'>
              <span className='labelText'>Net Amount </span>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                {numberFormat(valueForm.totalAmountIncludeVat)}
                <span style={{ marginLeft: '5px', fontWeight: 'bold' }}>{` ${defaultCurrency}`}</span>
              </div>
            </div>
          </div>
          {
            recommendItems && recommendItems.length > 0 ? 
            <div className='recommendItemContainer'>
              <span className='sectionTitle'>
                Recommend Items
              </span>
              {recommendItems.map(i => 
                <Card 
                  key={i.itemName}
                  style={{ cursor: 'pointer', marginTop: '8px' }} 
                  onClick={() => {
                    const newItem = { 
                      itemName: i.itemName, 
                      menuSubCategory,
                      quantity: 0, 
                      unit: '', 
                      unitPrice: 0, 
                      totalAmount: 0,
                      currency: defaultCurrency,
                      costCenter: costCenterByRequester
                    }
                    showPrItemModal(true, true, newItem, onSubmitItem(fields,change))
                  }}
                >
                  <CardContent style={{ padding: '8px' }}>
                    <span className='itemTitle'>
                      {i.itemName}
                    </span>
                  </CardContent>
                </Card> 
              )}
            </div> : null
          }
        </CardContent>  
      </Card>
    </SelectItemsContainer>
  )
}

const SelectPrItems = (props) => {

  const { valueForm, change,
    unitOptions, currencyOptions, budgetTypeOptions, accountAssignmentOptions, 
    materialGroupOptions, plantOptions, storageLocationOptions, recommendItems,
    showPrItemModal, subCategory, showModal, getWbsElements,
    purchasingGroupOptions, glAccountOptions, costCenterOptions,
    assetOptions, orderOptions, purchasingOrgOptions, profitCenterOptions, wbsOptions } = props
  
  const costCenterByRequester = valueForm && valueForm.costCenterByRequester ? valueForm.costCenterByRequester : ''
  const recItems = valueForm && valueForm.menuSubCategory ?
                         recommendItems.filter(i => i.subCategoryCode === valueForm.menuSubCategory ) : []
  const items = valueForm ? valueForm.items ? valueForm.items : [] : []
  const budgetData = valueForm && valueForm.budgetData ? valueForm.budgetData : { costCenter: [], wbs: [], internalOrder: [] }

  const [showBudgets, setShowBudgets] = useState(true)

  useEffect(() => {
    if(valueForm){
      if (valueForm.items.length && wbsOptions.length) {
        calculateTotalAmount(valueForm.items,change,true)
        calculateVat(valueForm.items,valueForm.vatRate,change,true)
        calculateTotalIncludeVat(valueForm.items,valueForm.vatRate,change,true)
        const newRawData = summaryDataForCheckBudget(valueForm)
        props.validateBudget(newRawData, onValidateBudgetSuccess({newRawData, change, costCenterOptions, glAccountOptions, wbsOptions, orderOptions}))
      }
    }
  },[valueForm.items, wbsOptions])

  useEffect(() => {
    if(valueForm){
      if (valueForm.items.length && wbsOptions.length) {
        calculateTotalAmount(valueForm.items,change,true)
        calculateVat(valueForm.items,valueForm.vatRate,change,true)
        calculateTotalIncludeVat(valueForm.items,valueForm.vatRate,change,true)
        const newRawData = summaryDataForCheckBudget(valueForm)
        props.validateBudget(newRawData, onValidateBudgetSuccess({newRawData, change, costCenterOptions, glAccountOptions, wbsOptions, orderOptions}))
      }
    }
  },[valueForm.documentDate])

  useEffect(() => {
    if (!wbsOptions.length) {
      getWbsElements(valueForm.companyCode)
    } else {
      if (wbsOptions[0].companyCode !== valueForm.companyCode) {
        getWbsElements(valueForm.companyCode)
      }
    }
  },[valueForm.companyCode])
  
  useEffect(() => {
    const { 
      valueForm: { menuSubCategory }, 
      companyPlantMapping, plantOptions, 
      materialOptions, getMaterials } = props
      
    if (menuSubCategory === 'G16-1') {
      const plantByCompany = companyPlantMapping.filter(cp => cp.companyCode === valueForm.companyCode) || []
      let availablePlant = []
      if (plantByCompany) {
        availablePlant = plantOptions.filter(p => plantByCompany.find(b => b.plantCode === p.value) !== undefined)
      } else {
        availablePlant = plantOptions
      }

      if (availablePlant.length) {
        availablePlant.forEach(p => {
          if(!materialOptions[p.value]) {
            getMaterials(p.value)
          }
        })
      }
    }
  },[])
  
  useEffect(() => {
    let index
    let indexIn
    props.menus.every((element,i) => {
      indexIn = element.subCategories.findIndex(x=>x.code === valueForm.menuSubCategory)
      if(indexIn>=0){
        index = i
        return false
      }
      return true
    })
    if(index>=0&&indexIn>=0){
      selectSubCategory(props.menus[index].subCategories[indexIn])
    }
  })
  return (
    <Fade in={true} timeout={1000}>
      <ProcurementBody>
        <FieldArray
          name='items'
          items={items}
          change={change}
          showPrItemModal={showPrItemModal}
          accountAssignmentOptions={accountAssignmentOptions}
          assetOptions={assetOptions}
          budgetTypeOptions={budgetTypeOptions}
          costCenterOptions={costCenterOptions}
          costCenterByRequester={costCenterByRequester}
          currencyOptions={currencyOptions}
          glAccountOptions={glAccountOptions}
          menuSubCategory={valueForm.menuSubCategory}
          materialGroupOptions={materialGroupOptions}
          orderOptions={orderOptions}
          plantOptions={plantOptions}
          profitCenterOptions={profitCenterOptions}
          purchasingGroupOptions={purchasingGroupOptions}
          purchasingOrgOptions={purchasingOrgOptions}
          recommendItems={recItems}
          storageLocationOptions={storageLocationOptions}
          unitOptions={unitOptions}
          valueForm={valueForm}
          wbsOptions={wbsOptions}
          vatRate={valueForm.vatRate}
          defaultCurrency={props.defaultCurrency}
          showModalAlert={props.showModalAlert}
          subCategory={subCategory}
          component={renderTableItems} />
          <BudgetContainer>
            <Card>
              <CardHeader 
                title={
                  <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <span className='MuiTypography-root MuiCardHeader-title MuiTypography-h5 MuiTypography-displayBlock' style={{ marginRight: '10px' }}>Budget Information</span>
                    {props.budgets.length==0&&props.validatingBudget ? <CircularProgress size={20} color='primary' /> : null}
                  </div>
                }
                action={
                  <div className='cardHeaderActions'>
                    {showBudgets ? 
                      <Button type='button' circular icon='chevron up' onClick={() => setShowBudgets(false)} /> : 
                      <Button type='button' circular icon='chevron down' onClick={() => setShowBudgets(true)} />}
                  </div>
                }
              />
              <Collapse in={showBudgets}>
                <CardContent>
                  <div>
                    {
                      budgetData.costCenter.length > 0 ?
                      <div className='budgetTable'>
                        <span className='tableTitle'>Cost Center</span>
                        <RTable
                          columns={costCenterColumn}
                          data={budgetData.costCenter}
                          minRows={budgetData.costCenter.length || 1}
                          showPagination={false}
                        />
                      </div> : null
                    }
                    {
                      budgetData.wbs.length > 0 ?
                      <div className='budgetTable'>
                        <span className='tableTitle'>Work Breakdown Structure (WBS)</span>
                        <RTable
                          columns={wbsColumn}
                          data={budgetData.wbs}
                          minRows={budgetData.wbs.length || 1}
                          showPagination={false}
                        />
                      </div> : null
                    }
                    {
                      budgetData.internalOrder.length > 0 ?
                      <div className='budgetTable'>
                        <span className='tableTitle'>Internal Order</span>
                        <RTable
                          columns={internalOrderColumn}
                          data={budgetData.internalOrder}
                          minRows={budgetData.internalOrder.length || 1}
                          showPagination={false}
                        />
                      </div> : null
                    }
                  </div>
                </CardContent>
              </Collapse>
            </Card>
          </BudgetContainer>
        {showModal ? <ItemModal subCategory={subCategory} /> : null}
      </ProcurementBody>
    </Fade>
  )
}

const mapStateToProps = (state) => {
  var valueForm = getFormValues('formEditPR')(state)
  let subCategory = state.pr.subCategory
  let mappingPurchasingGroups = state.mappingData.purchasingGroups.data

  // for Edit
  if(subCategory&&Object.keys(subCategory).length){
    if (subCategory && subCategory.purchasingGroup && typeof(subCategory.purchasingGroup) === 'string') {
      subCategory.purchasingGroup = JSON.parse(subCategory.purchasingGroup)
    }
    
    if (subCategory.purchasingGroup.length >= 1) {
      if (subCategory.purchasingGroup.length === 1) {
        valueForm.purchasingGroup = subCategory.purchasingGroup[0]
      } else {
        let purchasingGroupByCompany = mappingPurchasingGroups.find(m => m.companyCode === valueForm.companyCode)
        if (purchasingGroupByCompany) {
          subCategory.purchasingGroup.forEach(p => {
            let match = purchasingGroupByCompany.purchasingGroups.find(pg => pg === p)
            if (match) {
              valueForm.purchasingGroup = match
            }
          })
        }
      }
    }
  }

  let companyCode = valueForm.companyCode || ''
  let assetOptions = state.options.assets.data.filter(a => a.companyCode === companyCode)

  const orderOptions = state.options.orders.data.map(o => ({
    ...o,
    text: o.text.removeLeadingZero(),
  }))

  let defaultCurrency = 'THB'
  if(valueForm.items && valueForm.items.length > 0){
    let item = valueForm.items.find(x=>!x.deleted) 
    if(item){
      defaultCurrency = item.currency
    }
  } 

  return ({
    accountAssignmentOptions: state.options.accountAssignments.data,
    assetOptions,
    attachmentTypes: state.pr.attachmentTypes,
    budgetTypeOptions: state.options.budgetTypes.data,
    companyPlantMapping: state.mappingData.companyPlants.data,
    costCenterLoading: state.options.costCenters.loading,
    costCenterOptions: state.options.costCenters.data,
    currencyOptions: state.options.currencies.data,
    defaultCurrency,
    glAccountLoading: state.options.glAccounts.loading,
    glAccountOptions: state.options.glAccounts.data,
    mappingWbsAssets: state.mappingData.wbsAssets.data,
    materialGroupOptions: state.options.materialGroups.data,
    materialOptions: state.options.materials.data,
    orderOptions,
    plantOptions: state.options.plants.data,
    profitCenterOptions: state.options.profitCenters.data,
    purchasingOrgOptions: state.options.purchasingOrgs.data,
    purchasingGroupLoading: state.options.purchasingGroups.loading,
    purchasingGroupOptions: state.options.purchasingGroups.data,
    recommendItems: state.pr.recommendItems.data,
    showModal: state.pr.showPrItemModal,
    storageLocationOptions: state.options.storageLocations.data,
    unitOptions: state.options.units.data,
    wbsOptions: state.options.wbsElements.data,
    budgets: state.pr.budgets,
    validatingBudget: state.pr.validatingBudget,
    valueForm,
    pr: state.pr.prFormData.pr,
    menus: state.pr.menus,
  })
}

const mapDispatchToProps = {
  showPrItemModal,
  getWbsElements,
  validateBudget,
  getMaterials,
  selectSubCategory,
  showModalAlert
}

export default connect(mapStateToProps, mapDispatchToProps)(SelectPrItems)
